import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  stress_tests_result_article15: {
    name: 'Results of stress tests performed in accordance with point(b) of Article 15(3)',
    order: 279
  },
  stress_tests_result_article16: {
    name: 'Results of stress tests performed in accordance with the second subparagraph of Article 16(1)',
    order: 280
  }
};

export function ResultStressTest({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.RESULT_OF_STRESS_TESTS,
    onChangeFund,
    schema: schema.RESULT_OF_STRESS_TESTS,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.RESULT_OF_STRESS_TESTS?.field_names || [],
    columnLables,
    isMultiFunds,
    funds,
    tableName: 'RESULT_OF_STRESS_TESTS'
  });

  return (
    <Table
      id="reporttables-result-stress-test-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
